import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertBanner = ({ alerts, onAcknowledge, onInvestigate }) => {
  if (!alerts || alerts?.length === 0) return null;

  const criticalAlerts = alerts?.filter(alert => alert?.severity === 'critical');
  const highAlerts = alerts?.filter(alert => alert?.severity === 'high');

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-error/10 border-error text-error';
      case 'high':
        return 'bg-warning/10 border-warning text-warning';
      case 'medium':
        return 'bg-accent/10 border-accent text-accent';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertTriangle';
      case 'high':
        return 'AlertCircle';
      case 'medium':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  return (
    <div className="w-full mb-6 md:mb-8">
      {criticalAlerts?.length > 0 && (
        <div className="bg-error/5 border-2 border-error rounded-xl p-4 md:p-6 mb-4 animate-pulse">
          <div className="flex flex-col lg:flex-row lg:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-error/10 flex items-center justify-center flex-shrink-0">
                <Icon name="AlertTriangle" size={24} className="text-error" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base md:text-lg font-semibold text-error mb-1">
                  Peringatan Kritis: {criticalAlerts?.length} Transaksi Mencurigakan Terdeteksi
                </h3>
                <p className="text-sm text-foreground/80 mb-3">
                  {criticalAlerts?.[0]?.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {criticalAlerts?.slice(0, 3)?.map((alert) => (
                    <span
                      key={alert?.id}
                      className="inline-flex items-center gap-1.5 px-3 py-1 bg-error/10 text-error rounded-lg text-xs font-medium"
                    >
                      <Icon name="Shield" size={14} />
                      Skor Risiko: {alert?.riskScore}%
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 lg:flex-shrink-0">
              <Button
                variant="destructive"
                iconName="Eye"
                iconPosition="left"
                onClick={() => onInvestigate(criticalAlerts?.[0])}
                className="w-full sm:w-auto"
              >
                Investigasi Sekarang
              </Button>
              <Button
                variant="outline"
                iconName="Check"
                iconPosition="left"
                onClick={() => onAcknowledge(criticalAlerts?.[0]?.id)}
                className="w-full sm:w-auto"
              >
                Tandai Ditinjau
              </Button>
            </div>
          </div>
        </div>
      )}
      {highAlerts?.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {highAlerts?.slice(0, 2)?.map((alert) => (
            <div
              key={alert?.id}
              className={`border-2 rounded-xl p-4 ${getSeverityColor(alert?.severity)}`}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-8 h-8 rounded-lg bg-current/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={getSeverityIcon(alert?.severity)} size={18} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold mb-1">{alert?.title}</h4>
                  <p className="text-xs opacity-80 line-clamp-2">{alert?.description}</p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium">
                  {alert?.transactionCount} transaksi
                </span>
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="ArrowRight"
                  iconPosition="right"
                  onClick={() => onInvestigate(alert)}
                >
                  Detail
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AlertBanner;